import { render, staticRenderFns } from "./MoveToAnotherUserModal.vue?vue&type=template&id=34b9a08a&"
import script from "./MoveToAnotherUserModal.vue?vue&type=script&lang=js&"
export * from "./MoveToAnotherUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports